if(!sessionStorage.getItem('albedo_analytics_uuid')) {
    sessionStorage.setItem('albedo_analytics_uuid', generateUUID())
}

function getDeviceType() {
    const width = window.innerWidth;
    if (width <= 768) return "mobile";
    if (width <= 1024) return "tablet";
    return "desktop";
}

function generateUUID() {
    let d = new Date().getTime();
    let d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now()*1000)) || 0;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        let r = Math.random() * 16;//random number between 0 and 16
        if(d > 0){//Use timestamp until depleted
            r = (d + r)%16 | 0;
            d = Math.floor(d/16);
        } else {
            r = (d2 + r)%16 | 0;
            d2 = Math.floor(d2/16);
        }
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
}

const sendData = (payload) => {
    if (navigator.sendBeacon) {
        const blob = new Blob([JSON.stringify(payload)], {type : 'application/json'})
        navigator.sendBeacon(`/api/event-stream`, blob)
    }else{
        window.API.post('/event-stream', payload).catch(() => {})
    }
}

const getMetadata = () => {
    return {
        page: window.location.href,
        session_id: sessionStorage.getItem('albedo_analytics_uuid'),
        referrer: document.referrer,
        device: getDeviceType(),
    }
}

export const AlbedoAnalyticsEvent = (payload) => {
    const metadata = getMetadata();
    sendData({...payload, ...{metadata}, ...{event_date: new Date()}})
}

export const AlbedoAnalytics = {
    install(app, options) {
        if (!options.router) {
            console.warn('[AlbedoAnalyticsPlugin] router is required')
            return
        }

        const {
            router,
            minTime = 1000,
            onSend = () => {}
        } = options

        let startTime = Date.now()

        const sendSPA = (path) => {
            const timeMs = Date.now() - startTime
            if (timeMs < minTime) return
            const payload = {
                event_type: 'location',
                event_date: new Date,
                metrics: {
                    time_seconds: Math.round(timeMs / 1000),
                    value: path
                },
                metadata: getMetadata()
            }
            onSend(payload)
            sendData(payload)
            startTime = Date.now()
        }

        const sendUnload = () => {
            const timeMs = Date.now() - startTime
            if (timeMs < minTime) return
            const payload = {
                event_type: 'location',
                event_date: new Date,
                metrics: {
                    time_seconds: Math.round(timeMs / 1000),
                    value: router.currentRoute.value.fullPath
                },
                metadata: getMetadata()
            }

            onSend(payload)
            sendData(payload)
        }

        // Router guard dla SPA
        router.beforeEach((to, from, next) => {
            if (from?.fullPath) {
                sendSPA(from.fullPath)
            }
            next()
        })

        // Zamknięcie karty / refresh
        window.addEventListener('beforeunload', sendUnload)

        // Cleanup przy odmontowaniu
        app.mixin({
            unmounted() {
                window.removeEventListener('beforeunload', sendUnload)
            }
        })

        window.addEventListener('CookieScriptAcceptAll', function() {
// Kiedy użytkownik zaakceptuje wszystkie ciasteczka
            AlbedoAnalyticsEvent({
                event_type: "cookies-accepted-all",
            });
        });

        window.addEventListener('CookieScriptAccept', function(e) {
// Kiedy użytkownik zaakceptuje wybrane kategorie (jeśli używasz kategorii)
            AlbedoAnalyticsEvent({
                event_type: "cookies-accepted",
                metrics: {
                    value: e.detail.categories,
                },
            });
        });

        window.addEventListener('CookieScriptReject', function() {
// Kiedy użytkownik odrzuci ciasteczka
            AlbedoAnalyticsEvent({
                event_type: "cookies-rejected",
            });
        });

        document.addEventListener("click", function (e) {
            const link = e.target.closest("a");
            if (!link) return;

            const url = new URL(link.href, window.location.origin);

            // 1️⃣ Link zewnętrzny
            if (url.hostname !== window.location.hostname) {
                AlbedoAnalyticsEvent({
                    event_type: "external-link",
                    metrics: {
                        value: url.href
                    },
                });
                return;
            }

            // 2️⃣ Link do pliku
            const fileExtensions = /\.(pdf|docx?|xlsx?|zip|rar|mp4|mp3)$/i;
            if (fileExtensions.test(url.pathname)) {
                AlbedoAnalyticsEvent({
                    event_type: "link-to-file",
                    metrics: {
                        value: url.href
                    },
                });
            }
        });
    }
}
